// utils/apiClient.js
import axios from "axios";
import { server } from "../constants";

// Cookie-based auth (withCredentials) works fine on the website, but is
// unreliable inside Capacitor (mobile) / Electron WebViews — cross-origin
// cookies often don't persist or get sent there. The backend's
// isAuthenticated middleware already accepts a Bearer token as a fallback
// (see middleware/auth.js), so this reads the JWT fresh from localStorage
// on every request and attaches it as Authorization: Bearer <token>.
// Result: auth works on web (via cookie), Electron, and mobile (via
// Bearer) without any backend change.
const createApi = () => {
  const instance = axios.create({ baseURL: server, withCredentials: true });

  // Only attach the token to requests that are actually going to OUR
  // backend. Without this check, if any request ever passed an absolute
  // URL through this instance (axios lets an absolute `url` override
  // `baseURL`) — e.g. a future call to Google, Cloudinary, or any other
  // third-party API reusing this same client — the interceptor would
  // attach the user's JWT to that outgoing request too, since it runs
  // unconditionally for every request on this instance. Relative paths
  // (the normal case, e.g. "/students") are always same-origin and safe.
  const isOwnBackendRequest = (config) => {
    if (!config.url) return true;
    // Relative path (no scheme) — always resolves against baseURL.
    if (!/^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(config.url)) return true;
    try {
      return new URL(config.url).origin === new URL(server).origin;
    } catch {
      return false;
    }
  };

  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token && isOwnBackendRequest(config)) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  return instance;
};

export default createApi;
